import { SingleSelection } from 'src/components';
import { useTranslation } from 'src/hooks';

interface IProps {
  label?: string;
  value: any;
  onChange: (e: any) => void;
  onClear: () => void;
  revertEnum?: boolean;
}

const YesNoSingleSelection = (props: IProps) => {
  const { label, value, onChange, onClear } = props;

  const { tc } = useTranslation();

  const NormalEnum = {
    [tc('yes')]: true,
    [tc('no')]: false,
  };

  const RevertedEnum = {
    [tc('yes')]: false,
    [tc('no')]: true,
  };

  const Enum = props.revertEnum ? RevertedEnum : NormalEnum;

  return (
    <SingleSelection
      label={label || ''}
      value={isNaN(Number(value)) ? '' : value}
      onChange={onChange}
      clearSelect={onClear}
      enumData={Enum}
      nameFn={(name) => name}
      isNoSorting
    />
  );
};

export default YesNoSingleSelection;
